import { createSelector } from 'reselect';
import { selectCurrentCoursePath } from '../../location/CurrentCoursePath/selectors';
import { courseMembershipSelector } from '../../CourseMembership/selectors';
import { cohortsSelector } from '../../Cohorts/selectors';

export const selectCurrentCohortPath = createSelector(
  selectCurrentCoursePath,
  courseMembershipSelector,
  (coursePath, courseMembershipList) => {
    if (coursePath && courseMembershipList) {
      const courseMembership = courseMembershipList.get(coursePath);
      return courseMembership ? courseMembership.get('activeCohortPath') : null;
    }
    return null;
  }
);

export const selectCurrentActiveCohort = createSelector(
  selectCurrentCohortPath,
  cohortsSelector,
  (currentCohortPath, cohorts) => {
    if (currentCohortPath && cohorts) {
      return cohorts.get(currentCohortPath);
    }
    return null;
  }
);

export const selectActiveCohortStartDate = (state, course) => {
  let startDate = null;
  // get default cohort start date
  if (course && course.get('startDate')) {
    startDate = course.get('startDate');
  }
  // overwrite with current active cohort start date
  const currentActiveCohort = selectCurrentActiveCohort(state);
  if (currentActiveCohort && currentActiveCohort.get('startDate')) {
    startDate = currentActiveCohort.get('startDate');
  }
  return startDate;
};
